import React from 'react';
import IconButton from './IconButton';
import { ButtonProps } from './Button';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { AppRoutes } from '@monorepo/shared/src/types';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string) => translate('a11y', key);

const FamilyResourcesButton: React.FC<ButtonProps> = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.buttonContainer} style={props.containerStyle}>
      <IconButton
        icon={faClipboardList}
        aria-label={tA11y('buttons.familyResourcesButton')}
        redirectRoute={{
          path: `/${AppRoutes.FAMILY_RESOURCES}`,
          title: AppRoutes.FAMILY_RESOURCES,
        }}
        {...props}
      />
      {props.showTextLabel && (
        <Box className={classes.label}>{t('buttonsLabel.familyResourcesLabel')}</Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  buttonContainer: {
    width: remCalc(80),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  label: {
    paddingTop: '1rem',
    textAlign: 'center',
    fontFamily: FONT_GSS_FUTURA,
  },
}));

export default FamilyResourcesButton;
